import { ohrAxiosProtected as axios } from '../httpInstance/http'

export const sendAppLinkToWhatsapp = () => {
    return axios.get(`/oh_www/wa/ohapp/send`)
}
